import { useContext } from "react";
import Avatar from "@coworker/app/src/components/Avatar/Avatar";
import { logEvent } from "@coworker/app/src/helpers/tracker";
import { useUID } from "@coworker/app/src/core/auth/useLoggedInUser";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import TabNavigation from "./components/TabNavigation/TabNavigation";
import GlobalSearch from "./components/GlobalSearch/GlobalSearch";
import HejAppSwitcher from "./components/HejAppSwitcher/HejAppSwitcher";
import "./main-header.css";
import HamburgerMenu from "./components/HamburgerMenu/HamburgerMenu";
import { ModalAction, ModalContext } from "../../context/ModalContextProvider";
import { ModalType } from "../../context/modalType";
import { Profile } from "../../../home/components/Profile/Profile";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { useTranslation } from "@coworker/locales";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaWindow } from "@coworker/reusable/helpers/devices";
import { NotificationsInbox } from "@coworker/apprestructured/src/notifications/components/NotificationsInbox";

const handleProfileLinkClick = (toggleModal: (action: ModalAction) => void) => {
  logEvent("ce:hej_profile_link_clicked");
  toggleModal({ type: ModalType.Profile });
};

const MainHeader = () => {
  const uid = useUID();
  const navigate = useFixaNavigate();
  const { t } = useTranslation();
  const { toggleModal } = useContext(ModalContext);
  const { enableNotifications } = window as FixaWindow;

  return (
    <div className="main-header">
      <div className="left-side">
        <>
          <HamburgerMenu />
          <h1
            tabIndex={0}
            role={"button"}
            aria-label={t("goToHomePageString")}
            onClick={() => navigate("/")}
          >
            Fixa
          </h1>
          <TabNavigation />
        </>
      </div>
      <div className="right-side">
        <GlobalSearch />
        {enableNotifications ? <NotificationsInbox /> : null}
        <FixaButton
          inverseTheme
          aria-label={t("goToProfilePageString")}
          type="tertiary"
          onClick={() => {
            handleProfileLinkClick(toggleModal);
            trackerHelper.trackProfileButtonClick();
          }}
          className="profile-link"
        >
          <Avatar uid={uid} big={false} />
        </FixaButton>
        <Profile />
        <HejAppSwitcher />
      </div>
    </div>
  );
};

export default MainHeader;
